const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/reducers/labReportsReducer.ts';
import Imm from 'immutable';
import { IActionHandlersMap, makeReducer } from '../defs/actionTypes';
import { actionTypes } from '../actions/labReportsActions';
import { loadCumulConfigHandlers } from './labReports/loadCumulConfigHandlers';
import { loadCumulDefsHandlers } from './labReports/loadCumulDefsHandlers';
import { loadCumulDefsExtrasHandlers } from './labReports/loadCumulDefsExtrasHandlers';
import { loadLabSingleReportsHandlers } from './labReports/loadLabSingleReportsHandlers';
import { load1LabSingleReportHandlers } from './labReports/load1LabSingleReportHandlers';
import { updateLabSingleReportHandlers } from './labReports/updateLabSingleReportHandlers';
import { loadLabSingleRepRightsHandlers } from './labReports/loadLabSingleRepRightsHandlers';
import { labRepInstanceReducer, initialState as instanceInitState } from './labRepInstanceReducer';

export const initialState = Imm.fromJS({
    loading: {
        // Maps 'config' -> count
        // Maps 'cumulDefs' -> count
        // Maps 'singleReports' -> patnr -> count
    },

    config: {
        // Global config, only for the new Kumulativbefund
    },

    cumulDefs: {
        // Maps defsId to definitions. These stay the same for any patient
        // and data and do never change.
    },

    // Maps SENDER_REPORTNR to single-result report data.
    singleReports: {},

    index: {
        singleRepByPat: {
            // Maps patnr -> [singleRepId].
        },
    },

    // Maps singleRepIds to report-specific rights.
    rights: {},

    // Per-instance state
    instances: {},
});

const handlers: IActionHandlersMap = {
    [actionTypes.loadCumulConfig.pending]: loadCumulConfigHandlers.pending,
    [actionTypes.loadCumulConfig.success]: loadCumulConfigHandlers.success,
    [actionTypes.loadCumulConfig.failure]: loadCumulConfigHandlers.failure,

    [actionTypes.loadCumulDefs.pending]: loadCumulDefsHandlers.pending,
    [actionTypes.loadCumulDefs.success]: loadCumulDefsHandlers.success,
    [actionTypes.loadCumulDefs.failure]: loadCumulDefsHandlers.failure,

    [actionTypes.loadCumulDefsExtras.pending]: loadCumulDefsExtrasHandlers.pending,
    [actionTypes.loadCumulDefsExtras.success]: loadCumulDefsExtrasHandlers.success,
    [actionTypes.loadCumulDefsExtras.failure]: loadCumulDefsExtrasHandlers.failure,

    [actionTypes.loadLabSingleReports.pending]: loadLabSingleReportsHandlers.pending,
    [actionTypes.loadLabSingleReports.success]: loadLabSingleReportsHandlers.success,
    [actionTypes.loadLabSingleReports.failure]: loadLabSingleReportsHandlers.failure,

    [actionTypes.load1LabSingleReport.pending]: load1LabSingleReportHandlers.pending,
    [actionTypes.load1LabSingleReport.success]: load1LabSingleReportHandlers.success,
    [actionTypes.load1LabSingleReport.failure]: load1LabSingleReportHandlers.failure,

    [actionTypes.updateLabSingleReport.pending]: updateLabSingleReportHandlers.pending,
    [actionTypes.updateLabSingleReport.success]: updateLabSingleReportHandlers.success,
    [actionTypes.updateLabSingleReport.failure]: updateLabSingleReportHandlers.failure,

    [actionTypes.loadLabSingleRepRights.pending]: loadLabSingleRepRightsHandlers.pending,
    [actionTypes.loadLabSingleRepRights.success]: loadLabSingleRepRightsHandlers.success,
    [actionTypes.loadLabSingleRepRights.failure]: loadLabSingleRepRightsHandlers.failure,
};

const labRepBaseReducer = makeReducer(handlers, initialState);

export function labReportsReducer(state: any = initialState, action: any = {}) {
    // NOTE: action may be any action from the entire app!
    // The following is not necessarily a lab instanceId!
    const instanceId = action.instanceId ?? action.meta?.instanceId;

    if (instanceId) {
        // Let the instance reducer handle this action.

        let instance = state.getIn(['instances', instanceId]) ?? instanceInitState;
        instance = labRepInstanceReducer(instance, action);

        if (instance === instanceInitState) {
            // The action wasn't handled by labRepInstanceReducer.
            // Maybe the instanceId is not a lab instanceId at all!
        } else {
            state = state.setIn(['instances', instanceId], instance);
        }
    } else {
        // Let the base reducer handle this action.
        state = labRepBaseReducer(state, action);
    }

    return state;
}
